var utils = require( '../global/utils' );

var header_menu = ( function( $ ) {

	var $nav;

	var _init = function() {
		$nav = $( '#header .nav' );

		if ( utils.viewport_size().width >= 1320 ) {
			_setup_submenu_transition();
		}
	};

	var _setup_submenu_transition = function() {
		$nav.find( 'li.menu-item-has-children' ).find( 'ul.sub-menu' ).addClass( 'out' );

		$nav.find( 'li.menu-item-has-children' ).on( 'mouseenter', _add_submenu_transition_class );

		$nav.find( 'li.menu-item-has-children' ).on( 'mouseleave', function() {
			var $this = $( this );

			_remove_submenu_transition_class( $this );

			setTimeout( function() {
				$this.find('ul.sub-menu').addClass( 'out' );
			}, 200 );

		} );
	};

	var _add_submenu_transition_class = function() {
		$( this ).find( 'ul.sub-menu' ).first().addClass( 'anim-in' );
		$( this ).find( 'ul.sub-menu' ).first().removeClass( 'out' );
	};

	var _remove_submenu_transition_class = function( $submenu ) {
		$submenu.find( 'ul.sub-menu' ).removeClass( 'anim-in' );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = header_menu;